import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for ResultsPage
 *
 */

const ResultsPage = lazyLoad(
  () => import('app/modules/IntelligentSearch'),
  (module) => module.default,
);

export default ResultsPage;
